
  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */
$(() => {
  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function refreshCartFromApi() {
    jQuery.getJSON('/cart.js', function(cart) {
      refreshCart(cart)
    })
  }

  function updateCartItemQuantity(cartItem) {
    const oldQtyLineItem = isNaN(cartItem.oldQtyLineItem) ? 0 : cartItem.oldQtyLineItem;

    if (cartItem.limit !== undefined && cartItem.limit !== null) {
        // Primero verificar que la cantidad individual no exceda el límite
        if (cartItem.quantity > cartItem.limit) {
            showAjaxError(`Limit of ${cartItem.limit} unit/s per order.`);
            cartItem.$element.find('[data-cart-quantity-input]').val(oldQtyLineItem);
            return false;
        }
        
        // Ahora verificar que la cantidad total del producto en todo el carrito no exceda el límite
        // Obtener el carrito actual para verificar la cantidad total
        $.getJSON('/cart.js', function(cart) {
            const productId = cartItem.$element.data('product-id');
            let totalProductQuantity = 0;
            
            // Sumar todas las cantidades de este producto en el carrito
            cart.items.forEach(item => {
                if (item.product_id === productId) {
                    totalProductQuantity += item.quantity;
                }
            });
            
            // Restar la cantidad anterior y sumar la nueva
            const newTotalQuantity = totalProductQuantity - oldQtyLineItem + cartItem.quantity;
            
            if (newTotalQuantity > cartItem.limit) {
                showAjaxError(`Limit of ${cartItem.limit} unit/s per order. Total quantity would be ${newTotalQuantity}.`);
                cartItem.$element.find('[data-cart-quantity-input]').val(oldQtyLineItem);
                return false;
            }
            
            // Si pasa la validación, proceder con la actualización
            proceedWithCartUpdate(cartItem);
        });
        
        return; // Salir de la función aquí
    }
    
    // Si no hay límite, proceder directamente
    proceedWithCartUpdate(cartItem);
  }

  function proceedWithCartUpdate(cartItem) {

    $.ajax({
        url: '/cart/change.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: {
            quantity: cartItem.quantity,
            line: cartItem.lineID,
        },
        success(data) {
            const cartItemsArray = data.items;
            const lineIDIndex = cartItem.lineID - 1;
            const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
            const lineLimit = cartItem.parentCartForm.find('[metafield-limit-value]')
            const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
            let initialQuantityTotal = 0;
            let apiQuantityTotal = 0;
            const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
            // Verifica si el artículo tiene una oferta "Buy X get Y"
            if ($quantityInputs.length > 1) {
                // Múltiples entradas

                // Obtiene todas las cantidades de las mismas variantes en el carrito (incluyendo BOGO) en HTML
                $.each($quantityInputs, (_i, input) => {
                    initialQuantityTotal += parseInt($(input).val());
                });
                cartItemsArray.forEach(item => {
                    if (item.variant_id === cartItem.variantID) {
                        apiQuantityTotal += item.quantity;
                    }
                });
            } else {
                // Una sola entrada
                initialQuantityTotal = parseInt($quantityInputs.val());
                apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
            }

            // Verifica si hay suficiente inventario para actualizar a una cantidad mayor
            if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
                let itemsLeftText = '';
                if (apiQuantityTotal === 1) {
                    itemsLeftText = window.PXUTheme.translation.one_item_left;
                } else {
                    itemsLeftText = window.PXUTheme.translation.items_left_text;
                }

                $('.warning--quantity').remove();

                // Verifica si es un producto "Buy one get one"
                if (totalCartItems < cartItemsArray.length) {
                    refreshCart(data);
                } else {
                    cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
                }
            } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
                // Actualiza el carrito si hay inventario disponible
                refreshCart(data);
            } else {
                refreshCart(data);
            }
        },
        error: function(xhr, text) {
            $('.ajax-error-message').text(xhr.responseJSON.message);
            $(".ajax-error-modal").fadeIn(300);
            refreshCartFromApi();
            setTimeout(function() {
                $(".ajax-error-modal").fadeOut(300);
            }, 5000);
        }
    });
  }


  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  let metafieldLimits = {};

  function captureMetafields() {
      $('.mini-cart__item').each(function () {
          const $item = $(this);
          const productId = $item.data('product-id');
          const limitValue = $item.data('metafield-limit-value');

          // Guarda el Metafield en un objeto usando productId como clave
          if (productId && limitValue !== undefined) {
              metafieldLimits[productId] = limitValue;
          }
      });
  }

  function validateCartLimits(cart) {
      // Verificar que ningún producto exceda su límite
      cart.items.forEach(item => {
          const limit = metafieldLimits[item.product_id];
          if (limit && item.quantity > limit) {
              console.warn(`Product ${item.product_id} exceeds limit: ${item.quantity} > ${limit}`);
              // Aquí podrías mostrar un mensaje de error o tomar acción correctiva
          }
      });
  }

  function refreshCart(cart) {
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartActionStickyHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let cartActionStickyCountHTML = '';
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;
    let apiQuantityTotal = 0;
    let subtotalSummary  = 0;
    let hasShippingItem = false;

    if (window.PXUTheme && window.PXUTheme.productMetafields) {
      Object.assign(metafieldLimits, window.PXUTheme.productMetafields);
    }

    captureMetafields();

    let cartItemsWithoutDeposits = [];
      cart.items.forEach((item, index) => {
        const productId = item.product_id;
        if (!item.handle.includes('deposits')) {
          cartItemsWithoutDeposits.push({ ...item, lineIndex: index + 1});
          if (item.requires_shipping) {
            hasShippingItem = true;
        }
      }
    });

    if (hasShippingItem) {
    $('.wrapper-gift-packaging').show();
    } else {
      $('.wrapper-gift-packaging').hide();
    }
      
    if (cartItemsWithoutDeposits.length === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.subtotal-summary-container').addClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
      $('.subtotal-summary-container').removeClass('hidden');

      let totalSaving = 0;
      let saving = 0;
      

      cartItemsWithoutDeposits.forEach(item => {
        apiQuantityTotal += item.quantity;
        subtotalSummary += item.final_line_price
      });

      $.each(cartItemsWithoutDeposits, (index, item) => {
        const itemDiscounts = item.discounts;
        const lineID = index + 1;
        const titleToShow = item.product_title;
        const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span>`;
        const limitValue = metafieldLimits[item.product_id] || 1000;
        let maxQuantity = 1000;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-line-product-id="${item.lineIndex}" data-variant-id="${item.id}" data-product-id="${item.product_id}" data-old-quantity="${item.quantity}" data-metafield-limit-value="${limitValue}">`
                + `<a href="${item.url}">`;

    // Comprobar si el producto tiene imagen; de lo contrario, usar imagen por defecto
     const imageUrl = item.image 
      ? item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')
      : 'https://cdn.shopify.com/s/files/1/2479/4148/files/no-image.png?v=1722999394';
      
          cartItemsHTML += `${'<div class="cart_image">'
            + '<img src="'}${imageUrl}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${titleToShow}</a>`;
    
        if (item.properties && item.product_type != 'Event') {
        let renderedPropertiesCount = 0;
        $.each(item.properties, (title, value) => {
          if (value && title != '__shopify_send_gift_card_to_recipient' && title != 'Gift Product Title' && title != 'Gift SKU') {
            // Cambiar el título de 'Gift Note Packaging' a 'Message'
            if (title == 'Gift Note Packaging') {
              title = 'Message';
            }
            cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
            renderedPropertiesCount++;
            
            if (renderedPropertiesCount >= 2) {
              return false; // Similar a "break" en un bucle tradicional
            }
          }
        });
      }

        cartItemsHTML += '</div>'
        cartItemsHTML += '<div class="is-flex is-align-center" style="width: 100%;">'
        cartItemsHTML += '<div class="is-flex is-align-center" style="width: 100%;">'

        if(!item.title.includes('Gift Card') && item.product_type !== 'Packaging-Web') {
            cartItemsHTML += '<div class="product-quantity-box">';
            cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
            cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
            cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
            cartItemsHTML += '</div>';
        }

        cartItemsHTML += '<div class="mini-cart__item-price">';

        // Precio unitario
        cartItemsHTML += `<span class="money">${item.price === 0 ? 'Free' : itemPrice}</span></strong>`

        if (item.unit_price_measurement && item.price > 0) {
            let unitPriceMeasurementReferenceValue = '';

            if (item.unit_price_measurement.reference_value !== 1) {
                unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
            }

            cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
          item.line_level_discount_allocations.forEach((allocation) => {
            const title = allocation.discount_application && allocation.discount_application.title
              ? allocation.discount_application.title
              : '';
            if (title) {
              cartItemsHTML += `<p class="notification-discount meta"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7 V17 a2 2 0 0 0 2 2 h16 a2 2 0 0 0 2-2 v-2 a3 3 0 0 1 0-6 V7 a2 2 0 0 0-2-2 H4 a2 2 0 0 0-2 2 z" stroke="#EE5E18" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 8.5L12.88 10.79L15.33 10.92L13.43 12.46L14.06 14.83L12 13.5L9.94 14.83L10.57 12.46L8.67 10.92L11.12 10.79Z" fill="#EE5E18" stroke="#EE5E18" stroke-width="1.5" stroke-linejoin="round"/></svg>${htmlEncode(title)}</p>`;
            }
          });
        }

        cartItemsHTML += '</div></div>'
        cartItemsHTML += `<button type="button" class="js-cart-remove-btn cart__remove-btn" data-line-product-id="${item.lineIndex}" data-line-id="${lineID}" data-remove-item="mini-cart" aria-label=${JSON.stringify((window.PXUTheme.translation && window.PXUTheme.translation.cart_remove_text) || '')}><span class="remove-icon" aria-hidden="true"></span><svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.33331 3.99992C1.33331 3.63173 1.63179 3.33325 1.99998 3.33325H14C14.3682 3.33325 14.6666 3.63173 14.6666 3.99992C14.6666 4.36811 14.3682 4.66659 14 4.66659H1.99998C1.63179 4.66659 1.33331 4.36811 1.33331 3.99992Z" fill="#475467"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66669 2.00008C6.48988 2.00008 6.32031 2.07032 6.19528 2.19534C6.07026 2.32037 6.00002 2.48994 6.00002 2.66675V3.33341H10V2.66675C10 2.48994 9.92978 2.32037 9.80476 2.19534C9.67973 2.07032 9.51016 2.00008 9.33335 2.00008H6.66669ZM11.3334 3.33341V2.66675C11.3334 2.13631 11.1226 1.62761 10.7476 1.25253C10.3725 0.877462 9.86379 0.666748 9.33335 0.666748H6.66669C6.13625 0.666748 5.62755 0.877462 5.25247 1.25253C4.8774 1.62761 4.66669 2.13631 4.66669 2.66675V3.33341H3.33335C2.96516 3.33341 2.66669 3.63189 2.66669 4.00008V13.3334C2.66669 13.8638 2.8774 14.3726 3.25247 14.7476C3.62755 15.1227 4.13625 15.3334 4.66669 15.3334H11.3334C11.8638 15.3334 12.3725 15.1227 12.7476 14.7476C13.1226 14.3726 13.3334 13.8638 13.3334 13.3334V4.00008C13.3334 3.63189 13.0349 3.33341 12.6667 3.33341H11.3334ZM4.00002 4.66675V13.3334C4.00002 13.5102 4.07026 13.6798 4.19528 13.8048C4.32031 13.9298 4.48988 14.0001 4.66669 14.0001H11.3334C11.5102 14.0001 11.6797 13.9298 11.8048 13.8048C11.9298 13.6798 12 13.5102 12 13.3334V4.66675H4.00002Z" fill="#475467"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.33335 6.66675C9.70154 6.66675 10 6.96522 10 7.33341V11.3334C10 11.7016 9.70154 12.0001 9.33335 12.0001C8.96516 12.0001 8.66669 11.7016 8.66669 11.3334V7.33341C8.66669 6.96522 8.96516 6.66675 9.33335 6.66675Z" fill="#475467"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.66667 6.66675C7.03486 6.66675 7.33333 6.96522 7.33333 7.33341V11.3334C7.33333 11.7016 7.03486 12.0001 6.66667 12.0001C6.29848 12.0001 6 11.7016 6 11.3334V7.33341C6 6.96522 6.29848 6.66675 6.66667 6.66675Z" fill="#475467"></path></svg></button>`;
    });

  
      cartActionStickyCountHTML += `<span class="cart_count_items">${apiQuantityTotal} items</span>`;

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(subtotalSummary, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      cartActionStickyHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(subtotalSummary, $('body').data('money-format'))}</span></span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.menu-mobile-banner #count').html(apiQuantityTotal);
    const $mobileCountContainer = $('.count-header-mobile');
    const $mobileCount = $mobileCountContainer.find('.count');
    if ($mobileCount.length) {
      $mobileCount.text(apiQuantityTotal);
    } else {
      $mobileCountContainer.append(`<span class="count">${apiQuantityTotal}</span>`);
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_subtotal-sticky').html(cartActionStickyHTML);
    $('.js-cart_subtotal-count').html(cartActionStickyCountHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
    
    // Validar límites del carrito después de la actualización
    validateCartLimits(cart);
    
    // Asegurar que los atributos data-old-quantity estén correctamente configurados
    setTimeout(() => {
      $('[data-cart-quantity-input]').each(function() {
        const $input = $(this);
        const $cartItem = $input.closest('[data-cart-item]');
        const currentValue = parseInt($input.val(), 10);
        
        // Si no hay data-old-quantity o es 0, configurarlo con el valor actual
        if (!$cartItem.data('old-quantity') || parseInt($cartItem.data('old-quantity'), 10) === 0) {
          $cartItem.attr('data-old-quantity', currentValue);
        }
      });
    }, 100);
  }

  $('body').on('change', '[data-cart-quantity-input]', function () {
    const $cartItemElement = $(this).parents('[data-cart-item]');
    const limitElement = $cartItemElement.data('metafield-limit-value');
    const newQuantity = parseInt($(this).val(), 10);
    const oldQuantity = parseInt($cartItemElement.data('old-quantity'), 10) || 0;
    
    const cartItem = {
      lineID: $cartItemElement.data('line-product-id'),
      variantID: $cartItemElement.data('variant-id'),
      priceItem: $cartItemElement.find('.modal_price span .money').text(),
      quantity: newQuantity,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $cartItemElement,
      oldQtyLineItem: oldQuantity
    };

    if (limitElement !== undefined && limitElement !== null && parseInt(limitElement, 10) > 0) {
        cartItem.limit = parseInt(limitElement, 10);
        
        // Validación inmediata antes de proceder
        if (newQuantity > cartItem.limit) {
            // Restaurar la cantidad anterior en lugar de ajustar al límite
            $(this).val(oldQuantity);
            cartItem.quantity = oldQuantity;
            
            // Mostrar mensaje informativo
            showAjaxError(`Cannot exceed limit of ${cartItem.limit} units per order. Quantity restored to ${oldQuantity}.`);
            
            // No proceder con la actualización
            return;
        }
    }

    if (!$('body').hasClass('cart')) {
      updateCartItemQuantity(cartItem);
    }
    
  });

  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-product-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]'),
    };
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
      cartItem.$element.addClass('slide-out-right');
      let item = this.closest('.mini-cart__item');
      item.classList.add('slide-out-right');
    }

    updateCartItemQuantity(cartItem);
    
  });

  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        const $addToCartBtn = $addToCartForm.find('.add_to_cart');

        const $quantityInputs = parseInt($addToCartForm.find('.quantity').val());

        // Obtener el valor máximo permitido desde el data attribute
        const maxQuantity = parseInt($('#product-details').data('max-quantity')) || null;

        if ($('body').hasClass('cart')) {
            $addToCartForm.submit();
            return;
        }

        jQuery.getJSON('/cart.js', function(cart) {
            const preAddCartSignature = cartQuantitySignature(cart);
            const $productDiv = $('.main [data-product-id]');
            const productId = $productDiv.attr('data-product-id');
            const idProductLimit = parseInt(productId, 10);
            let limitedProduct = cart.items.find(item => item.product_id === idProductLimit);

            const currentInCart = limitedProduct ? limitedProduct.quantity : 0;
            const remaining = maxQuantity ? Math.max(0, maxQuantity - currentInCart) : Infinity;

            if (maxQuantity && remaining <= 0) {
                showAjaxError(`Limit of ${maxQuantity} unit/s per order.`);
                return false;
            }

            const qtyToAdd = (maxQuantity && $quantityInputs > remaining) ? remaining : $quantityInputs;
            const wasCapped = qtyToAdd < $quantityInputs;

            if (wasCapped) {
                $addToCartForm.find('.quantity').val(qtyToAdd);
            }

            $.ajax({
                url: '/cart/add.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: $addToCartForm.serialize(),
                beforeSend() {
                    // Verificar si estamos en la página de Gift Card
                    if ($('body').hasClass('product-gift-card')) {
                        const isInDrawer = $addToCartForm.closest('.drawer-content').length > 0;
                        if (isInDrawer) {
                            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                            $addToCartBtn.addClass('background-image-none');
                            return true;
                        }
                        if (!validateGiftCardFields()) {
                            return false;
                        }
                    }
                    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                    $addToCartBtn.addClass('background-image-none');
                    $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
                },
                success() {
                    if (wasCapped) {
                        $addToCartForm.find('.quantity').val($quantityInputs);
                    }
                    $('.drawer-container').addClass('open-drawer');
                    resetGiftCardFields();
                    handleAddToCartSuccess($addToCartBtn);
                    if (wasCapped) {
                        showAjaxError(`Only ${qtyToAdd} unit/s were added. Limit of ${maxQuantity} unit/s per order.`, false);
                    }
                },
                error(xhr, text) {
                    if (wasCapped) {
                        $addToCartForm.find('.quantity').val($quantityInputs);
                    }
                    handleAddToCartError(xhr, $addToCartBtn, preAddCartSignature);
                }
            });
        });

        return false;
    });
  }

  function validateGiftCardFields() {
      const email = $('#recipient-email').val().trim();
      const name = $('#recipient-name').val().trim();
      const cardGiftMessage = $('#recipient-message').val().trim();
      const sendOnDate = $('#recipient-send-on').val().trim();

      if (email === "") {
          showAjaxError('Please enter an Email');
          return false;
      }
      if (name === "") {
          showAjaxError('Please enter a Name.');
          return false;
      }
      if (cardGiftMessage === "") {
          showAjaxError('Please enter a Message');
          return false;
      }
      if (sendOnDate === "") {
          showAjaxError('Please choose a date.');
          return false;
      }
      return true;
  }

  function resetGiftCardFields() {
      $('#recipient-email').val('');
      $('#recipient-name').val('');
      $('#recipient-message').val('');
  }

  function handleAddToCartSuccess($addToCartBtn) {
      $addToCartBtn.find('.checkmark').addClass('checkmark-active');
      window.setTimeout(() => {
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.removeClass('background-image-none');
          $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          $.ajax({
              url: '/cart.js',
              dataType: 'json',
              cache: false,
              success(cart) {
                  refreshCart(cart);
                  setTimeout(function () {
                      if ($('body').hasClass('fancybox-active')) {
                          $.fancybox.close();
                      }
                      blockScrollingOnMobile();
                  }, 500);
              },
          });
      }, 1000);
      handleCartLinkActivation();
  }

  function cartQuantitySignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return '';
    var lines = cart.items.map(function (i) {
      return String(i.variant_id) + ':' + String(i.quantity);
    });
    lines.sort();
    return String(cart.item_count || 0) + '|' + lines.join(',');
  }

  function handleAddToCartError(xhr, $addToCartBtn, preAddCartSignature) {
      var msg =
        xhr.responseJSON && xhr.responseJSON.message
          ? xhr.responseJSON.message
          : xhr.statusText || 'Error';
      $addToCartBtn.removeAttr('disabled').removeClass('disabled');
      $addToCartBtn.removeClass('background-image-none');
      $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
      $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');

      // Mismo overlay que showAjaxError (antes solo se animaba el modal y no el backdrop).
      showAjaxError(msg, true);

      // Shopify puede responder 422 cuando se agrega menos unidades por inventario.
      // Si el carrito no cambió (p. ej. ya estaba al máximo), solo mostramos el error.
      jQuery.getJSON('/cart.js', function (cart) {
        var cartChanged =
          preAddCartSignature === undefined ||
          preAddCartSignature === null ||
          cartQuantitySignature(cart) !== preAddCartSignature;
        if (cartChanged) {
          refreshCart(cart);
          if (cart.items && cart.items.length > 0) {
            $('.drawer-container').addClass('open-drawer');
            handleCartLinkActivation();
            setTimeout(function () {
              if ($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }
              blockScrollingOnMobile();
            }, 500);
          }
        }
      });
  }

  function handleCartLinkActivation() {
      if ($('#header').is(':visible')) {
          $('#header .cart-container').addClass('active_link');
      } else if ($('.sticky_nav--stick').length) {
          $('.sticky_nav .cart-container').addClass('active_link');
      } else {
          $('.top-bar .cart-container').addClass('active_link');
      }
  }

  function blockScrollingOnMobile() {
      if (window.PXUTheme.media_queries.medium.matches) {
          const header = document.getElementById('header');
          if (header.classList.contains('mobile_nav-fixed--false')) {
              window.scroll({ top: 0, left: 0, behavior: 'smooth' });
          }
      }
  }

  function showAjaxError(message, showBackdrop = true) {
    $('.ajax-error-message').text(message);
    if (showBackdrop) $('.ajax-error-backdrop').stop(true, true).fadeIn(150);
    $(".ajax-error-modal").fadeIn(300);
    setTimeout(function() {
        $(".ajax-error-modal").fadeOut(300);
        if (showBackdrop) $('.ajax-error-backdrop').fadeOut(300);
    }, 5000);
  }

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled')
        .removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked')
        .attr('disabled', 'disabled');
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};


$(document).on('shopify:block:select', e => {
    const { blockId } = e.detail;
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials') || $parentSection.hasClass('shopify-section--shoppable-image--slider-enabled')) {
      sliderBlock.select(blockId, $parentSection);
    }
  });

$(document).on('shopify:block:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      window.sliderBlock.deselect($parentSection);
    }
  });

$(document).on('shopify:section:reorder', e => {
    window.utils.initializeSectionWrapper();
  });

$(document).on('shopify:section:load', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    window.utils.initializeSectionWrapper();
    window.utils.enableDisclosure();

    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }

    if (window.PXUTheme.theme_settings.newsletter_popup) {
      window.newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--blog-template')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--product-sidebar')) {
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--page-tequila-template')) {
      window.gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      window.gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      window.accordion.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      window.cart.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      window.featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
    }

    if ($parentSection.hasClass('shopify-section--map')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }



    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      window.video.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template') || $parentSection.hasClass('shopify-section--quick-shop')) {
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.videoFeature.init();
      window.productPage.productSwatches();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--recommended-products')) {
      window.productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if (window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({ scrollTop: $('#new-comment').offset().top - 140 }, 'slow');
      }
    }

    if ($parentSection.hasClass('boost-sd__product-filter-fallback')) {
      window.collectionSidebarFilter.init();
      window.productPage.init();
      window.productPage.runOptionSelector($parentSection);
      window.sidebarAccordions.init();
      window.recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--contact-section')) {
      window.map.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (window.PXUTheme.theme_settings.enable_autocomplete) {
        window.searchAutocomplete.init();
      }
      window.collectionSidebarFilter.init();
      window.sidebarAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      window.meganavManager.injectAll();
      window.header.init();
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.add($parentSection[0]);
    }
  });

$(document).on('shopify:section:unload', e => {
    const $target = $(e.target);
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--header')) {
      window.header.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      window.slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.unload($parentSection.find('[data-logo-wrapper]'));
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      window.testimonials.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--shoppable-image')) {
      window.shoppableImage.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      window.searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-product')) {
      window.productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.remove($parentSection[0]);
    }

    // When sections are removed from the DOM, reinitialize the section wrapper
    window.requestAnimationFrame(() => {
      window.utils.initializeSectionWrapper();
    });
  });

$(document).on('shopify:section:select', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.select($parentSection[0]);
    }

    if ($parentSection.hasClass('shopify-section--logo-list')) {
      window.logoList.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      window.featuredCollection.unload($parentSection);
      window.featuredCollection.init();
    }

    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  });

$(document).on('shopify:section:deselect', e => {
    const $parentSection = $(`#shopify-section-${e.detail.sectionId}`);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      window.meganavManager.deselect();
    }
  });

  $(document).ready(function(){
  // Verificar si el cuerpo de la página tiene la clase 'product'
  if ($('body').hasClass('product') && 
    !$('.product-block--\\@app').find('.shopify_subscriptions_app_container').length) {
    function updatePricing() {
      var regex = /([0-9]+[.|,][0-9]+)/g;

      // Obtener los precios del HTML
      var unitPriceText = $('.product_section .price').text().match(regex);
      var unitPrice = unitPriceText ? parseFloat(unitPriceText[0].replace(",", "")) : null;

      // Verificar si existe el precio de comparación y asegurarse de que hay coincidencia con el regex
      var compareAtPriceElement = $('.product_section .compare-at-price');
      var compareAtPriceText = compareAtPriceElement.length ? compareAtPriceElement.text().match(regex) : null;
      var compareAtPrice = compareAtPriceText ? parseFloat(compareAtPriceText[0].replace(",", "")) : null;

      // Obtener la cantidad seleccionada
      var quantity = parseInt($('#quantity').val(), 10);

      // Ahorros en oferta: actualizar en desktop y mobile al cambiar cantidad.
        if (compareAtPrice > unitPrice) {
          var savingsPerUnit = compareAtPrice - unitPrice;
          var totalSavings = savingsPerUnit * quantity;
          var savingsPercentage = Math.round((savingsPerUnit / compareAtPrice) * 100);
          var formattedSavings = window.Shopify.formatMoney(totalSavings * 100, $('body').data('money-format'));

          var savingsElement = $('.sale.savings');
          if (savingsElement.length) {
            savingsElement.html(`Save <span class="money">${formattedSavings}</span> (${savingsPercentage}%)`);
          }
        } else {
          $('.sale.savings').empty();
         
      }

      // Precio en el botón solo con viewport ≥ 1024px (mismo criterio que CSS / sections.js)
      var showPriceInCartBtn = window.matchMedia('(min-width: 1024px)').matches;
      if (showPriceInCartBtn) {
        var totalPrice = unitPrice * quantity * 100;
        var totalPriceText = window.Shopify.formatMoney(totalPrice, $('body').data('money-format'));
        $('.purchase-details__buttons .add_to_cart .text').html('Add to cart ' + totalPriceText);
      } else {
        $('.purchase-details__buttons .add_to_cart .text').html('Add to cart');
      }
    }

    // Vincular la función a cambios en la cantidad
    $('.product-block--form #quantity').on('change', updatePricing);
    updatePricing(); // Para calcular el precio en el cargado inicial de la página

    var resizePricingTimer;
    $(window).on('resize', function () {
      clearTimeout(resizePricingTimer);
      resizePricingTimer = setTimeout(updatePricing, 150);
    });
  }
});

$('#show-password').css('display', 'none');

function activePass() {
  let x = document.getElementById("customer_password");
  let xx = document.getElementById("password");
  let showPass = document.getElementById("show-password");
  let hidePass = document.getElementById("hide-password");
  if (x && x.type === "password" || xx && xx.type === "password" ) {
    if(x) {
      x.type = "text";
    }
    if (xx) {
      xx.type = "text";
    }
    $('#show-password').css('display', 'block')
    $('#hide-password').css('display', 'none')
  } else {
    if(x) {
      x.type = "password";
    }
    if (xx) {
      xx.type = "password";
    }
    $('#show-password').css('display', 'none')
    $('#hide-password').css('display', 'block')
  }
}


$('.custom-radio-checkbox__input').click(function() {
    if($('.custom-radio-checkbox__input:checked').length == 2) {
      document.getElementById('form-submit-btn').disabled = false;
  } else {
  document.getElementById('form-submit-btn').disabled = true;
}
});

$(document).ready(function() {
  $('body').on('click', '#klaviyo-bis-trigger', e => {
    e.preventDefault();
    e.stopPropagation();

    const $this = $(e.currentTarget);

    // Encuentra los valores de idVariant y idProduct buscando inputs específicos cercanos al botón
    var idVariant = $this.siblings("input.first-variant").val();
    var idProduct = $this.siblings("input.idProduct").val();

    // Busca el título del producto en función del contexto
    var NameProduct = $this.siblings("input.titleProduct").val() || '';

    if (NameProduct === '') {
        NameProduct = $this.closest('.boost-sd__product-info').find('.boost-sd__product-title').text();
    }

    // Si no está en el contexto de Boost, buscar en el contexto de la página de producto
    if (NameProduct === '') {
        NameProduct = $this.closest('.product_details--product-page').find('.product-block--title').text();
    }

    // Si no está en product-column, buscar en el card del thumbnail
    if (NameProduct === '') {
        NameProduct = $this.closest('.product-details').find('.title a').text();
    }

    // Si aún no se encuentra, buscar en toda la página
    if (NameProduct === '') {
        NameProduct = $('h1').first().text();
    }
    
    // Convertir la primera letra de cada palabra a mayúscula
    if (NameProduct.length > 0) {
        NameProduct = NameProduct.split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    }
    
    // Mostrar el modal de KlaviyoBIS y actualizar su contenido
    $("#KlaviyoBIS").fadeIn();
    $('.klaviyo').find('h2').html(NameProduct);
    
    // Asigna los valores de idVariant y idProduct a los inputs ocultos dentro del formulario
    $("input[name='productVariant']").val(idVariant);
    $("input[name='productID']").val(idProduct);
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.klaviyo').length) {
      closeKlaviyoForm();
    }
  });

  $(".klaviyo").on('click', function(event) {
    event.stopPropagation();
  });
});

function closeKlaviyoForm() {
    $("#KlaviyoBIS").fadeOut()
};

function openModal(data) {
  $('#popupImage').attr('src', data.image || '');
  $('#popupText').html(data.text || '');
  var $acceptButton = $('#acceptButton');
  var $modalButtons = $('#modalButtons');
  if (data.acceptText && data.acceptText.trim()) {
    $acceptButton.text(data.acceptText).attr('href', data.acceptLink || '#').show();
    $modalButtons.show();
  } else {
    $acceptButton.hide();
    $modalButtons.hide();
  }
  $('#productPopup').fadeIn();
}

function closeModal() {
  $("#productPopup").fadeOut();
}

function closeModalStock() {
  $("#productPopupInfoStock").fadeOut();
}

function openInfoSheet(data) {
  var $imageWrap = $('#sheetImageWrap');
  var $img = $('#sheetImage');

  if (data.image) {
    $img.attr('src', data.image);
    $imageWrap.css({ height: '110px', opacity: '1' }).show();
  } else {
    $imageWrap.css({ height: '0px', opacity: '0' });
  }

  $('#sheetTitle').text(data.title || '');
  $('#sheetDescription').html(data.text || '');

  var $chips = $('#sheetChips').empty();
  if (data.chips) {
    data.chips.split(',').forEach(function(chip) {
      chip = chip.trim();
      if (chip) $chips.append('<span class="info-sheet__chip">' + chip + '</span>');
    });
  }

  var $rows = $('#sheetDetailRows').empty();
  [[data.detailLabel1, data.detailValue1], [data.detailLabel2, data.detailValue2], [data.detailLabel3, data.detailValue3]].forEach(function(pair) {
    if (pair[0] && pair[1]) {
      $rows.append(
        '<div class="info-sheet__row">' +
        '<span class="info-sheet__row-label">' + pair[0] + '</span>' +
        '<span class="info-sheet__row-value">' + pair[1] + '</span>' +
        '</div>'
      );
    }
  });

  var $footer = $('#sheetFooter').empty();
  if (data.acceptText && data.acceptText.trim()) {
    $footer.append(
      '<a class="info-sheet__cta global-button global-button__background" href="' + (data.acceptLink || '#') + '" target="_blank">' +
      data.acceptText + '</a>'
    );
  }

  $('#sheetScroll').scrollTop(0);
  $imageWrap.css({ height: '110px', opacity: '1' });

  $('#infoBottomSheet').fadeIn(200);
  $('body').addClass('sheet-open');
}

function closeInfoSheet() {
  $('#infoBottomSheet').fadeOut(200);
  $('body').removeClass('sheet-open');
}

function fadeOutOrder() {
 if(window.innerWidth < 798) {
    $('html, body').animate({
      scrollTop: 1680
  }, 'slow');
 } else  {
    $('html, body').animate({
      scrollTop: 700
  }, 'slow');
 }
 return false;
}

$(document).ready(function() {
  $('body').on('click', '.product-popup__link', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $this = $(this);
    var data = {
      title:        $this.data('popupTitle'),
      text:         $this.data('popupText'),
      image:        $this.data('popupImage'),
      chips:        $this.data('popupChips'),
      detailLabel1: $this.data('detailLabel1'),
      detailValue1: $this.data('detailValue1'),
      detailLabel2: $this.data('detailLabel2'),
      detailValue2: $this.data('detailValue2'),
      detailLabel3: $this.data('detailLabel3'),
      detailValue3: $this.data('detailValue3'),
      acceptLink:   $this.data('acceptLink'),
      acceptText:   $this.data('acceptText')
    };
    if (window.innerWidth < 798) {
      openInfoSheet(data);
    } else {
      openModal(data);
    }
  });

  $('#infoBottomSheet').on('click', function(e) {
    if ($(e.target).is('#infoBottomSheet')) closeInfoSheet();
  });

  $('#sheetScroll').on('scroll', function() {
    var scrollTop = this.scrollTop;
    var newHeight = Math.max(0, 110 - scrollTop * 1.4);
    var opacity = Math.max(0, 1 - scrollTop / 60);
    $('#sheetImageWrap').css({ height: newHeight + 'px', opacity: opacity });
  });

  $('body').on('click', '.product-popup_stock', function(e) {
    $('#productPopupInfoStock').fadeIn();
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.modal__centered-content').length) {
      closeModal();
    }
  });

  $('.modal__centered-content').on('click', function(event) {
    event.stopPropagation();
  });
});

$(document).on('click', '.fancybox-container', function() {
  closeModal();
});

$(document).ready(function() {
  function removeNextPrevious() {
    const prevLink = $('.prev a');
    const nextLink = $('.next a');
    prevLink.contents().filter(function() {
      return this.nodeType === 3;
    }).remove(); // Elimina el texto de prevLink
    nextLink.contents().filter(function() {
      return this.nodeType === 3;
    }).remove(); // Elimina el texto de nextLink
  }

  removeNextPrevious(); // Llama a la función al cargar la página
});

function handleModalRequestClick(title) {
  $("#modalRequest").show();
  $("#request-title-product").html(title);
  $("#contactFormMessage").html(`I would like to know the price of this product "${title}". `);
}

function handleHideModalRequest() {
  $("#modalRequest").hide()
};

function scrollDownProducts() {
  
  if (window.innerWidth < 798) {
    $('html, body').animate({
      scrollTop: 3100
    }, 'slow');
  } else {
    $('html, body').animate({
      scrollTop: 1600
    }, 'slow');
  }

  return false;
}

$(document).ready(function() {
    function positionWishlistBtn() {
      var $btn = $('wk-button');
      var $title = $('.product_name');

      if (!$btn.length || !$title.length) return;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      var isDesktop = viewportWidth >= 1200;
      if (!isDesktop) {
        $btn.css({
          top: '',
          bottom: '',
          transform: ''
        });
        return;
      }
        var containerTop = $btn.offsetParent().offset().top;
        var titleTop = $title.offset().top - containerTop;
        var titleHeight = $title.outerHeight();
        $btn.css({
          top: (titleTop + titleHeight / 2) + 'px',
          bottom: 'auto',
          transform: 'translateY(-50%)'
        });
      }

    var attempts = 0;
    var interval = setInterval(function() {
      if ($('wk-button').length && $('.product_name').length) {
        positionWishlistBtn();
        clearInterval(interval);
       $(window).on('resize', positionWishlistBtn);
      }
      if (++attempts > 30) clearInterval(interval);
    }, 100);

    $(window).on('load', positionWishlistBtn);
  });
